import React, {
  forwardRef,
  useState,
  useRef,
  useEffect,
  useContext,
} from "react";
import { useHistory } from "react-router-dom";
import {
  TextField,
  makeStyles,
  useTheme,
  FormControl,
  Button,
  CssBaseline,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Container,
  Paper,
  Typography,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Fab from "@material-ui/core/Fab";
import { useMutation } from "@apollo/client";
import { AddAlertContext } from "../../common/store";
import { addPartyComponent } from "../../styles/styles";
import { ADD_EDIT_USER } from "../../utils/graphQL/mutations";
import { GET_USERS } from "../../utils/graphQL/queries";
import Spinners from "../common/spinners";
import ConfirmationDialog from "../common/confirmationDialog";
import passwordGen from "../../common/randomPassword";
import * as val from "../../common/regex";
import AuthManager from "../../common/AuthManager";
import SAMSAPIService from "../../api/SAMSService";
import { Cached, FileCopy} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formGroup: {
    "& > *": {
      margin: theme.spacing(1),
      //   width: 200
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px",
    paddingLeft: "50px",
    paddingRight: "50px",
    width: "50%",
    margin: "auto",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  submitIcon: {
    margin: theme.spacing(2, 0, 2),
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    maxWidth: 300,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  number: {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
}));

function AddEditUser({ userEditData, title }) {
  let history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    contactNo: "",
    address: "",
  };
  const [typeName, setTypeName] = useState(initialState);
  const [bol, setBol] = useState(false);
  const [optionsValue, setoptionsValue] = useState();
  const [open, setOpen] = useState(false);
  const [pwdResetOpen, setpwdResetOpen] = useState(false);
  const [tokenresetOpen, settokenresetOpen] = useState(false);
  const [spinners, setSpinners] = useState(false);
  const [token, setToken] = useState('');
  const [addEditUser, { errors, data }] = useMutation(ADD_EDIT_USER, {
    errorPolicy: "all",
  });
  const [errMessage, seterrMessage] = useState("");
  const [autoPassword, setAutoPassword] = useState();
  const [successMessage, setsuccessMessage] = useState("");

  useEffect(()=>{
    if(userEditData){
      setBol(userEditData.is_active)
      setToken(userEditData.token??"")
    }
  },[userEditData])
  useEffect(() => {
    const randomPassword = passwordGen();
    setAutoPassword(randomPassword);
  }, []);

  const handleClickOpen = () => setOpen(true);

  const handlePwdClickOpen = () =>
    setpwdResetOpen((pwdResetOpen) => !pwdResetOpen);

  const handleClose = () => setOpen(false);

  const handleClickClose = (e) => e.preventDefault();

  const handleName = (e) => {
    e.preventDefault();
    if (e.target.name === "contactNo" && isNaN(e.target.value)) {
      seterrMessage("Please enter valid mobile number");
    }
    setTypeName({ ...typeName, [e.target.name]: e.target.value });
  };

  const handleChange = (e) => setoptionsValue(e.target.value);

  const handleRadioButton = (e) => {
    e.persist();
    if (e.target.value === "yes" || undefined || "") {
      setBol(true);
    } else if (e.target.value === "no") {
      setBol(false);
    }
  };

  const passwordReset = async (e) => {
    var tok = AuthManager.getToken();
    const res = await SAMSAPIService.doEmail(
      "user/password/generate",
      { email: userEditData.email, samsR: true },
      tok
    );
    setpwdResetOpen(false);
    if (res.valid)
      setsuccessMessage("Password Reset Mail has been sent to User !");
    else seterrMessage(res.message);
  };

  const handleValidation = (firstName, lastName, contactNo, address, token) => {
    if (
      val.isEmpty(firstName || typeName.firstName) ||
      !val.validate_firstName(firstName || typeName.firstName)
    ) {
      seterrMessage(
        "First Name should be greater than 0 and less than 15 characters"
      );
      setSpinners(false);
      handleClose();
      return false;
    } else if (
      val.isEmpty(lastName || typeName.lastName) ||
      !val.validate_firstName(lastName || typeName.firstName)
    ) {
      seterrMessage(
        "Last Name should be greater than 0 and less than 15 characters"
      );
      setSpinners(false);
      handleClose();
      return false;
    } else if (
      val.isEmpty(contactNo || typeName.contactNo) ||
      !val.phonenumber(contactNo || typeName.contactNo)
    ) {
      seterrMessage("Contact Number should have 10 Numbers");
      setSpinners(false);
      handleClose();
      return false;
    } else if (!val.validate_address(address || typeName.address)) {
      seterrMessage(
        "Address should be greater than 0 and less than 300 characters"
      );
      setSpinners(false);
      handleClose();
      return false;
    } else if (!token) {
      seterrMessage(
        "Token should be valid"
      );
      setSpinners(false);
      handleClose();
      return false;
    } else {
      return true;
    }
  };
  const handleUpdateUser = async (data) => {
    const response = await addEditUser({
      variables: data,
      refetchQueries: [{ query: GET_USERS }],
      awaitRefetchQueries: true,
    });
    if (response.errors) {
      seterrMessage(response.errors[0].message);
      setSpinners(false);
      handleClose();
      setToken("")
    } else {
      seterrMessage("");
      handleClose();
      setSpinners(false);
      setTypeName(initialState);
      setsuccessMessage("Successfully updated User");
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSpinners(true);
    setsuccessMessage("");
    let firstName = document.getElementById("firstName").value;
    let lastName = document.getElementById("lastName").value;
    let contactNo = document.getElementById("contactNo").value;
    let address = document.getElementById("address").value;
    if (handleValidation(firstName, lastName, contactNo, address, token)) {
      const data = {
        id: userEditData.id,
        first_name: typeName.firstName ? typeName.firstName : firstName,
        last_name: typeName.lastName ? typeName.lastName : lastName,
        email: typeName.email ? typeName.email : userEditData.email,
        mobile: typeName.contactNo ? typeName.contactNo : contactNo,
        address: typeName.address ? typeName.address : address,
        token: token,
        is_active: bol === "undefined" || null || "" ? true : bol,
      }
      handleUpdateUser(data)
    }
  };
  const handleGenerateToken = async (e) =>{
    e.preventDefault();
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var token_generated = '';
    for (var i = 0; i < 32; i++) {
        var randomPoz = Math.floor(Math.random() * charset.length);
        token_generated += charset.substring(randomPoz,randomPoz+1);
    }
    setToken(token_generated)
    settokenresetOpen(false)
    setSpinners(true);
    setsuccessMessage("");
    let firstName = document.getElementById("firstName").value;
    let lastName = document.getElementById("lastName").value;
    let contactNo = document.getElementById("contactNo").value;
    let address = document.getElementById("address").value;
    let token = token_generated
    if (handleValidation(firstName, lastName, contactNo, address, token)) {
      const data = {
        id: userEditData.id,
        first_name: typeName.firstName ? typeName.firstName : firstName,
        last_name: typeName.lastName ? typeName.lastName : lastName,
        email: typeName.email ? typeName.email : userEditData.email,
        mobile: typeName.contactNo ? typeName.contactNo : contactNo,
        address: typeName.address ? typeName.address : address,
        token: token,
        is_active: bol === "undefined" || null || "" ? true : bol,
      }
      handleUpdateUser(data)
    }
  }
  const handleGenerateTokenClick = () =>{
    settokenresetOpen(true)
  }
  const handleGenerateTokenClose =() =>{
    settokenresetOpen(false)
  }
  const onClickCopyToken=() =>{
  navigator.clipboard.writeText(document.getElementById("token").innerHTML);
  }
  return (
    <div>
      <Container component="main">
        <CssBaseline />
        <Paper className={classes.paper} elevation={5}>
          <Typography component="h1" variant="h5">
            {title ? title : "Create New User"}
          </Typography>

          <div style={{ color: "red", marginTop: "10px" }}>{errMessage}</div>
          <div style={{ color: "green", marginTop: "10px" }}>
            {successMessage}
          </div>
          {spinners && <Spinners />}
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  autoComplete="firstName"
                  // value={userEditData.first_name ? userEditData.first_name ? typeName.firstName}
                  defaultValue={
                    userEditData.first_name
                      ? userEditData.first_name
                      : typeName.firstName
                  }
                  onChange={handleName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="lastName"
                  // value={typeName.lastName}
                  defaultValue={
                    userEditData.last_name
                      ? userEditData.last_name
                      : typeName.lastName
                  }
                  onChange={handleName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                  // value={typeName.email}
                  onChange={handleName}
                  defaultValue={
                    userEditData.email ? userEditData.email : typeName.email
                  }
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  // className={classes.number}
                  variant="outlined"
                  required
                  fullWidth
                  id="contactNo"
                  label="Contact No"
                  name="contactNo"
                  // value={typeName.contactNo}
                  onChange={handleName}
                  inputProps={{ maxLength: 10 }}
                  // type="number"
                  defaultValue={
                    userEditData.mobile
                      ? userEditData.mobile
                      : typeName.contactNo
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="address"
                  label="Address"
                  name="address"
                  // value={typeName.address}
                  onChange={handleName}
                  multiline
                  rows={4}
                  rowsMax={6}
                  defaultValue={
                    userEditData.address
                      ? userEditData.address
                      : typeName.address
                  }
                />
              </Grid>
              <Grid item xs={12}>
              
              <FormLabel component="legend" style={{marginBottom:"10px"}}>Token</FormLabel>
              <Grid container >
                {(token) && 
                <Grid container xs={12}>
                <Grid item xs={10}>
              <Typography variant="body1" mt="2" name="token" id="token">
                {token?? ""}
              </Typography>
              </Grid>
                
              <Grid item xs={1} style={{marginLeft:"2px"}} >
              <IconButton aria-label="Copy" size="small">
                <FileCopy onClick={onClickCopyToken}/>
              </IconButton>
              </Grid>
              </Grid >
              }
              </Grid>
              <Grid item xs={12}>

              <Grid item xs={9} >
              <Button variant="contained" startIcon={<Cached />}
              onClick={handleGenerateTokenClick}
              color="primary"
              size="small"
              style={{ marginRight: "10px" }}
              className={classes.button}
              >
                REGENERATE TOKEN
              </Button>
                </Grid>
              </Grid>

              </Grid>

              <Grid item xs={12}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Status</FormLabel>
                  <RadioGroup
                    aria-label="activateAccount"
                    name="activateAccount"
                    id="activateAccount"
                    defaultValue={userEditData.is_active ? "yes" : "no"}
                    onChange={handleRadioButton}
                    style={{ flexDirection: "row" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Enable"
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="Disable"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              justify="space-between"
              spacing={2}
              // className={classes.submitIcon}
            >
              <Grid item justify="space-between" alignItems="flex-start">
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  className={classes.button}
                  onClick={handlePwdClickOpen}
                >
                  Password Reset
                </Button>
                {/* <Fab
                  size="small"
                  color="secondary"
                  aria-label="add"
                  onClick={() => {
                    history.push("/users");
                  }}
                >
                  <ArrowBackIcon />
                </Fab> */}
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  style={{ marginRight: "10px" }}
                  className={classes.button}
                  onClick={() => {
                    history.push("/users");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.button}
                  onClick={handleClickOpen}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
            {pwdResetOpen ? (
              <ConfirmationDialog
                open={pwdResetOpen}
                handleClose={handlePwdClickOpen}
                handleSubmit={passwordReset}
                dialogTitle="Are you sure you want to Reset Password ?"
              />
            ) : (
              <ConfirmationDialog
                open={open}
                handleClose={handleClose}
                handleSubmit={handleSubmit}
                dialogTitle="Are you sure you want to Update User ?"
              />
            )}
            {tokenresetOpen && <ConfirmationDialog
                open={tokenresetOpen}
                handleClose={handleGenerateTokenClose}
                handleSubmit={handleGenerateToken}
                dialogTitle="Are you sure you want to Reset Token ?"
              />}
          </form>
        </Paper>
      </Container>
    </div>
  );
}
export default AddEditUser;
